/**
 * getIntersection
 * @param {object} a object with left, right, top, bottom properties (e.g. el.getBoundingClientRect())
 * @param {object} b object with left, right, top, bottom properties (e.g. el.getBoundingClientRect())
 * @returns {object|undefined} an object representing the overlapping area of the two rectangles,
 * or undefined if there is no overlap
 */

module.exports = function getIntersection(a, b) {
    if (a.right <= b.left) return
    if (a.left >= b.right) return
    if (a.top >= b.bottom) return
    if (a.bottom <= b.top) return
    const left = Math.max(a.left, b.left)
    const top = Math.max(a.top, b.top)
    const right = Math.min(a.right, b.right)
    const bottom = Math.min(a.bottom, b.bottom)
    return { left, top, right, bottom }
}
